module.exports = __webpack_public_path__ + "media/assets/icons/share-7b49be8bc66895569a365c32db56acfb.svg";